<template>
  <div class="employee">
    <!-- <Add></Add> -->
    <div class="employee__top flex" v-if="role=='vendor'">
      <MyTransition :myName="'up'">
        <div class="add_menu" v-if="AddMenuStatus">
          <ul>
            <li @click="addEmployee">單一新增員工</li>
            <!-- <li>批次新增員工</li> -->
          </ul>
        </div>
      </MyTransition>
      <button type="button" class="btn_primary add" @click="openAddMenu">
        新增
        <span v-if="AddMenuStatus">
          <i class="el-icon-caret-top"></i>
        </span>
        <span v-else>
          <i class="el-icon-caret-bottom"></i>
        </span>
      </button>
      <!-- <button type="button" class="btn_primary add">搜尋</button> -->
    </div>
    <div v-else class="vendor_name" >
      {{$route.query.name}}
    </div>
    <List></List>
  </div>
</template>
<style lang="scss">
.employee {
  &__top {
    // justify-content: space-between;
    position: relative;
    .add_menu {
      top: 40px;
      position: absolute;
      z-index: 999;
      background: var(--mainColor2);
      border-radius: 5px;
      padding: 10px 0;
      color: #fff;
      box-shadow: 7px 7px 20px -10px rgba($color: #000000, $alpha: 0.5);
      ul {
        li {
          padding: 12px 20px;
          cursor: pointer;
          &:hover {
            font-weight: bold;
            background: #cdbaff;
            color: #fff;
          }
        }
      }
    }
    .add {
      // min-width: 100px;
      max-width:120px;
      // text-align: left;
      padding:8px 20px;
      border-radius: 50px;
      text-align: center;
    }
    > button {
      margin: 0 5px;
    }
  }
    .vendor_name{
      font-size: 23px;
      font-weight: bold;
      text-align: left;
      padding:0 20px;
      
    }
}
</style>
<script>
import Add from "./AddEmployee.vue";
import List from "./EmployeeList.vue";
export default {
  name: "employee",
  components: {
    Add,
    List
  },
  data() {
    return {
      AddMenuStatus: false
    };
  },
  computed: {
    role(){
      return this.$store.state.user.role
    }
  },
  methods: {
    openAddMenu(event) {
      this.AddMenuStatus = !this.AddMenuStatus;
    },
    addEmployee() {
      const path = this.$route.path.split('/')[1];
      this.$router.push(`/${path}/addemployee`)
    }
  }
};
</script>